export default "__VITE_ASSET__C5Udd9pj__"